import styled, { css } from 'styled-components'
import Tooltip from '../Tooltip'

interface ContainerProps {
  isFocused: boolean
  isFilled: boolean
  isErrored: boolean
  color?: string
}

export const LabelInput = styled.label`
  font-size: 1rem;
  line-height: 1.375rem;
  font-weight: 400;
  color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
`

export const Container = styled.div<ContainerProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  height: 43px;
  width: 100%;
  border-radius: 8px;
  border: solid 1px
    ${(props) => (props.color ? props.color : `rgb(${props.theme.component.accent})`)};
  margin-bottom: 0.8rem;

  a {
    width: 70px;
    height: 30px;
    text-decoration: ${({ theme }) => `underline rgb(${theme.primary.base})`};
    color: ${({ theme }) => `rgb(${theme.primary.base})`};
    font-weight: bold;
    font-size: 13px;
  }
  @media only screen and (min-width: 360px) {
    a {
      width: auto;
      height: 17px;
    }
  }

  ${(props) =>
    props.isErrored &&
    css`
      color: #c53030;
      border-color: #c53030;

      svg {
        color: #c53030 !important;
      }
    `}

  ${(props) =>
    props.isFocused &&
    css`
      color: ${({ theme }) => `rgb(${theme.primary.base})`};
      border-color: ${({ theme }) => `rgb(${theme.primary.base})`};

      svg {
        color: ${({ theme }) => `rgb(${theme.primary.base}) !important`};
      }
    `}

  ${(props) =>
    props.isFilled &&
    css`
      color: ${({ theme }) => `rgb(${theme.primary.base})`};

      svg {
        color: ${({ theme }) => `rgb(${theme.primary.base}) !important`};
      }
    `}

  input {
    background: transparent;
    flex: 1;
    border: 0;
    width: 2rem !important;
    font-weight: 500;
    color: ${({ theme }) => `rgb(${theme.grayscale[200]})`};
    font-size: 1rem;
    font-family: Montserrat;

    &:disabled {
      cursor: not-allowed;
    }
  }

  & + div {
    margin-top: 8px;
  }

  svg {
    margin-right: 8px;
    color: ${(props) => (props.color ? props.color : `rgb(${props.theme.component.accent})`)};
  }

  div {
    margin-top: 3px;
    cursor: pointer;
    svg {
      margin-left: 4px;
      margin-right: -5px;
      color: ${(props) => (props.color ? props.color : `rgb(${props.theme.component.accent})`)};
    }
  }
`

export const Error = styled(Tooltip)`
  svg {
    margin: 0;
  }

  span {
    background: #c53030;
    color: #fff;

    &::before {
      border-color: #c53030 transparent;
    }
  }
`
export const InformationTip = styled(Tooltip)`
  svg {
    margin: 0;
  }
  span {
    background: ${({ theme }) => `rgb(${theme.background.low})`};
    font-size: 12px;
    width: 15rem;
    &::before {
      border-color: ${({ theme }) => `rgb(${theme.component.accent}) transparent`};
    }
    margin-left: 0.5rem;
  }

  @media only screen and (max-width: 800px) {
    span {
      margin-left: -4rem;
    }
  }
`
